let searchPage = rootState => {
  let results = [];
  let search = new RegExp(rootState.pages.form.search, 'ig');
  let parent = '';
  rootState.pages.details.pages.map(page => {
    // search in category
    if (search.test(page.name)) {
      //results.push(page);
      if (parent != page.category) {
        results.push(page);
        parent = page.category;
      }
    } else if (page.subcategories !== undefined && page.subcategories !== null && page.subcategories.length > 0) {
      // search in subcategory
      page.subcategories.map(subpage => {
        if (search.test(subpage.name)) {
          //results.push(subpage);
          //results.push(page);
          if (parent != page.category) {
            results.push(page);
            parent = page.category;
          }
        }
      });
    }
  });
  rootState.pages.status = results.length > 0 ? 'Se encontraron ' + results.length + ' resultados' : 'Sin resultados';
  rootState.pages.details.pages = results;
};

const mutations = {
  setPages(state, pages) {
    state.details.pages = pages;
  },
  searchPage(state, value) {
    state.form.search = value;
    searchPage(this.state);
  },
  setStatus(state, status) {
    state.status = status;
  },
};
export default mutations;
